import { ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/modules/auth';

@Component({
  selector: 'app-expire-token-model',
  templateUrl: './expire-token-model.component.html',
  styleUrls: ['./expire-token-model.component.scss']
})
export class ExpireTokenModelComponent implements OnInit {

  // @Input() isOppend: boolean;
  @ViewChild("content", { static: true }) content: TemplateRef<any>;


  closeResult = '';
  value = 0
  showBar = false;
  dataNow;
  expireDate;
  different;
  interval;
  modalOption: NgbModalOptions = {};
  fakeInterval;

  constructor(
    private modalService: NgbModal,
    private _NgbProgressbarConfig: NgbProgressbarConfig,
    private changedetection: ChangeDetectorRef,
    private _AuthService: AuthService,
    private router: Router
  ) {
    // customize default values of progress bars used by this component tree
    _NgbProgressbarConfig.max = 30;
    _NgbProgressbarConfig.striped = true;
    _NgbProgressbarConfig.animated = true;
    _NgbProgressbarConfig.type = 'success';
    _NgbProgressbarConfig.height = '20px';

  }

  ngOnInit(): void {
    this.changedetection.detectChanges();
    this.startInterval();
    this.router.events.subscribe((val) => {
      // see also 
      if (val instanceof NavigationEnd && val.url != '/auth/login' && val.url != '/error' && val.url != '/auth/registration' && val.url != '/auth/forgot-password' && val.url != '/auth/logout') {
        // 
        // Check if user token will expired soon 
        // Show modal to refresh token
        // ==================[Start]======================
        this.dataNow = new Date();
        this.expireDate = new Date(localStorage.getItem('exspireIntime'));
        // Check if current date time bigger than expired date show model
        if (localStorage.getItem('exspireIntime') && this.dataNow > this.expireDate) {
          // 
          // 

          this.open(this.content);
          this.startFakeInterval();
        }
        // ==================[End]======================
      }
    });
  }

  open(content) {
    //  if (!this.modalService.hasOpenModals()) {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.ariaLabelledBy = 'modal-basic-title'
    this.modalService.open(content, this.modalOption).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    this.changedetection.detectChanges();
    //  }

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // Interval approach
  startInterval() {
    this.interval = setInterval(() => {
      let dataNow = new Date();
      let expireDate = new Date(localStorage.getItem('exspireIntime'));
      let different = this.getDifferenceInSeconds(dataNow, expireDate);
      if ((Math.ceil(different) == 30 || this.showBar) && expireDate > dataNow) {
        if (!this.showBar) {
          this.open(this.content)
        }
        this.showBar = true;
        this.value += 1;

        if (this.value == 30) {
          clearInterval(this.interval);
          this.logOut();
        }
        this.changedetection.detectChanges();
      }
    }, 1000);
  }


  refreshToken() {
    this._AuthService.refreshToke().subscribe((res: any) => {
      clearInterval(this.interval);
      clearInterval(this.fakeInterval);
      this.modalService.dismissAll();
      this.showBar = false;
      this.value = 0;
      let authData = this._AuthService.getAuthFromLocalStorage();
      this._AuthService.changeUserAuthData({ ...authData, accessToken: res.access_token })
      authData = this._AuthService.getAuthFromLocalStorage();


      let dataNow = new Date();
      // res.expires_in
      dataNow.setSeconds(dataNow.getSeconds() + res.expires_in)
      localStorage.setItem('exspireIntime', `${dataNow}`)
      this.changedetection.detectChanges();
      this.interval = ''
      this.startInterval();
    })
  }

  logOut() {
    this._AuthService.logout();
    this.modalService.dismissAll();
    document.location.reload();
  }


  getDifferenceInSeconds(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / 1000;
  }

  startFakeInterval() {
    this.fakeInterval = setInterval(() => {
      this.value += 1;
      if (this.value == 30) {
        clearInterval(this.interval);
        this.logOut();
      }
      this.changedetection.detectChanges();
    }, 1000)
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

}
